
import "@/assets/video/caption-selector.css"
import { isFullScreenAvailable } from "@/services/fullScreenService"
import { computed, ComputedRef, defineComponent, PropType, Ref, ref } from "vue"
import setUpFullScreen from "@/composables/shared/fullscreen-hander"
import { isMobile } from "@/services/deviceDetection"
import replaceclass from "@/services/replaceClass"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { getLanguageString } from "@/utils/getLanguageString"
export default defineComponent({
  props: {
    IS_IOS: { type: Boolean, required: true },
    playerContainer: {
      type: Object as PropType<Ref<HTMLElement | undefined>>,
      required: true
    },
    captionBtnString: { type: Object as PropType<Ref<String>>, required: true },
    canUseCaptions: {
      type: Object as PropType<Ref<Boolean>>,
      required: true
    },
    subtitleArray: {
      type: Object as PropType<Ref<SubtitleUrls[]>>,
      required: true
    },
    clickCaption: { type: Function, required: false },
    currentCaptions: { type: Object as PropType<Ref<String>>, required: true },
    height: { type: Object as PropType<ComputedRef<number>>, required: true }
  },
  setup(props) {
    let CAPTION_RADIO_OFF = `<svg class="caption-radio" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0Z" fill="#B7B7B7"/>
</svg>`
    let CAPTION_RADIO_ON = `<svg class="caption-radio" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect class="caption-radio" rx="6" fill="white"/>
</svg>`
    let captionHolder = ref<HTMLElement>()
    let captionScrollTimer = ref(0)
    let canFullScreen = ref(isFullScreenAvailable() && !props.IS_IOS)
    let { togglefullscreen } = setUpFullScreen(props.playerContainer)
    let captionScrollMargins = ref({
      "margin-left": `-${
        captionHolder.value ? captionHolder.value.clientWidth - 27 : 0
      }px !important`,
      "margin-top": `-${
        captionHolder.value ? captionHolder.value.clientHeight + 17 : 0
      }px !important`
    })
    let captionScrollHeight = computed(() => {
      return {
        height: `${
          (props.subtitleArray.value.length + 1) * 24 + 18 >
          props.height.value * 0.9
            ? props.height.value * 0.9
            : (props.subtitleArray.value.length + 1) * 24
        }px !important`
      }
    })

    return {
      captionScrollHeight,
      getLanguageString,
      CAPTION_RADIO_OFF,
      CAPTION_RADIO_ON,
      canFullScreen,
      togglefullscreen,
      captionScrollTimer,
      captionHolder,
      captionScrollMargins
    }
  },
  mounted() {
    this.setMargins()
  },
  methods: {
    onCaptionHover() {
      clearTimeout(this.captionScrollTimer)
    },
    offCaptionsHover() {
      this.captionScrollTimer = setTimeout(this.hideCaptions, 200)
    },
    showCaptions() {
      if (isMobile(navigator.platform, navigator.maxTouchPoints)) return
      clearTimeout(this.captionScrollTimer)
      replaceclass(this.captionHolder as HTMLElement, `hide`, `show`)
      this.setMargins()
    },
    hideCaptions() {
      clearTimeout(this.captionScrollTimer)
      replaceclass(this.captionHolder as HTMLElement, `show`, `hide`)
    },
    setMargins() {
      this.captionScrollMargins = {
        "margin-left": `-${
          this.captionHolder ? this.captionHolder.clientWidth - 27 : 0
        }px !important`,
        "margin-top": `-${
          this.captionHolder ? this.captionHolder.clientHeight + 17 : 0
        }px !important`
      }
    }
  }
})
